'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventEmitter = require('events').EventEmitter;
var W3CWebSocket = require('websocket').w3cwebsocket;
var retry = require('retry');
var logger = require('../logger')('WebSocketTransport');
var Message = require('../Message');

var WS_SUBPROTOCOL = 'protoo';
var DEFAULT_RETRY_OPTIONS = {
	retries: 10,
	factor: 2,
	minTimeout: 1 * 1000,
	maxTimeout: 8 * 1000
};

var WebSocketTransport = function (_EventEmitter) {
	_inherits(WebSocketTransport, _EventEmitter);

	function WebSocketTransport(url, options) {
		_classCallCheck(this, WebSocketTransport);

		logger.debug('constructor() [url:"%s", options:%o]', url, options);

		var _this = _possibleConstructorReturn(this, (WebSocketTransport.__proto__ || Object.getPrototypeOf(WebSocketTransport)).call(this));

		_this.setMaxListeners(Infinity);

		// Save URL and options.
		_this._url = url;
		_this._options = options || {};

		// WebSocket instance.
		_this._ws = null;

		// Closed flag.
		_this._closed = false;

		// Set WebSocket
		_this._setWebSocket();
		return _this;
	}

	_createClass(WebSocketTransport, [{
		key: 'send',
		value: function send(message) {
			if (this._closed) return Promise.reject(new Error('transport closed'));

			try {
				this._ws.send(JSON.stringify(message));

				return Promise.resolve();
			} catch (error) {
				logger.error('send() | error sending message: %o', error);

				return Promise.reject(error);
			}
		}
	}, {
		key: 'close',
		value: function close() {
			logger.debug('close()');

			if (this._closed) return;

			// Don't wait for the WebSocket 'close' event, do it now.
			this._closed = true;
			this.emit('close');

			try {
				this._ws.onopen = null;
				this._ws.onclose = null;
				this._ws.onerror = null;
				this._ws.onmessage = null;
				this._ws.close();
			} catch (error) {
				logger.error('close() | error closing the WebSocket: %o', error);
			}
		}
	}, {
		key: '_setWebSocket',
		value: function _setWebSocket() {
			var _this2 = this;

			var options = this._options;
			var operation = retry.operation(this._options.retry || DEFAULT_RETRY_OPTIONS);
			var wasConnected = false;

			operation.attempt(function (currentAttempt) {
				if (_this2._closed) {
					operation.stop();

					return;
				}

				logger.debug('_setWebSocket() [currentAttempt:%s]', currentAttempt);

				_this2._ws = new W3CWebSocket(_this2._url, WS_SUBPROTOCOL, options.origin, options.headers, options.requestOptions, options.clientConfig);

				_this2.emit('connecting', currentAttempt);

				_this2._ws.onopen = function () {
					if (_this2._closed) return;

					wasConnected = true;

					// Emit 'open' event.
					_this2.emit('open');
				};

				_this2._ws.onclose = function (event) {
					if (_this2._closed) return;

					logger.warn('WebSocket "close" event [wasClean:%s, code:%s, reason:"%s"]', event.wasClean, event.code, event.reason);

					// Don't retry if code is 4000 (closed by the server).
					if (event.code !== 4000) {
						// If it was not connected, try again.
						if (!wasConnected) {
							_this2.emit('failed', currentAttempt);

							if (operation.retry(true)) return;
						}
						// If it was connected, start from scratch.
						else {
								operation.stop();

								_this2.emit('disconnected');
								_this2._setWebSocket();

								return;
							}
					}

					_this2._closed = true;

					// Emit 'close' event.
					_this2.emit('close');
				};

				_this2._ws.onerror = function () {
					if (_this2._closed) return;

					logger.error('WebSocket "error" event');
				};

				_this2._ws.onmessage = function (event) {
					if (_this2._closed) return;

					var message = Message.parse(event.data);

					if (!message) return;

					if (_this2.listenerCount('message') === 0) {
						logger.error('no listeners for WebSocket "message" event, ignoring received message');

						return;
					}

					// Emit 'message' event.
					_this2.emit('message', message);
				};
			});
		}
	}, {
		key: 'closed',
		get: function get() {
			return this._closed;
		}
	}]);

	return WebSocketTransport;
}(EventEmitter);

module.exports = WebSocketTransport;


//////////////////
// WEBPACK FOOTER
// ./~/protoo-client/lib-es5/transports/WebSocketTransport.js
// module id = 689
// module chunks = 0